import {
  MODULE_TREE_PIN_LEVELS,
  resolvePinnedVirtualScrollHierarchyMap
} from '@/ui/utils/resolvePinnedVirtualScrollHeaders';

function resolveMap(params) {
  return resolvePinnedVirtualScrollHierarchyMap(MODULE_TREE_PIN_LEVELS, params);
}

/** @returns {object|null} 고정할 Array row */
export function resolvePinnedModuleTreeArrayRow(params) {
  return resolveMap(params).array ?? null;
}

/** @returns {object|null} 고정할 String row */
export function resolvePinnedModuleTreeStringRow(params) {
  return resolveMap(params).string ?? null;
}

/** @returns {{ arrayRow: object|null, stringRow: object|null }} */
export function resolvePinnedModuleTreeHierarchyRows(params) {
  const map = resolveMap(params);
  return {
    arrayRow: map.array ?? null,
    stringRow: map.string ?? null
  };
}
